/**
 * import main Carousel Slider function
 */
 import createCarouselSlider from '../libs/carousel-slider';

 export function coverflowSlider() {
   /**
  * Carousel Slider element
  */
    const sliderEl = document.querySelector('.carousel-slider');

    /**
     * Init Carousel Slider
     *
     * argument: pass .carousel-slider element
     */

    if (sliderEl)
      createCarouselSlider(sliderEl);
}

